// Returns a performance-optimized version of an image URL.
// - Local /images/*.jpg|png -> pre-generated .webp sibling (same name).
// - Unsplash -> auto=format (WebP/AVIF) and width capped to `maxW`.
// - Pexels -> compressed + width capped.
// Original files are kept for Open Graph / social sharing.
export function optimizedSrc(src, maxW = 900) {
  if (!src) return src;
  if (src.startsWith("/images/")) {
    const [path, query] = src.split("?");
    const webp = path.replace(/\.(jpe?g|png)$/i, ".webp");
    return query ? `${webp}?${query}` : webp;
  }
  try {
    const u = new URL(src);
    if (u.hostname === "images.unsplash.com") {
      const w = parseInt(u.searchParams.get("w") || "0", 10);
      const h = parseInt(u.searchParams.get("h") || "0", 10);
      if (!w || w > maxW) {
        if (w && h) u.searchParams.set("h", String(Math.round((h * maxW) / w)));
        u.searchParams.set("w", String(maxW));
      }
      u.searchParams.set("auto", "format");
      u.searchParams.set("q", "70");
      return u.toString();
    }
    if (u.hostname === "images.pexels.com") {
      u.searchParams.set("auto", "compress");
      u.searchParams.set("cs", "tinysrgb");
      u.searchParams.set("w", String(maxW));
      return u.toString();
    }
  } catch (e) {
    return src;
  }
  return src;
}

// Absolute URL (for SEO / JSON-LD / Open Graph).
export const SITE_URL = "https://www.maggiecadetmd.com";
export function absoluteUrl(src) {
  if (!src) return src;
  return src.startsWith("http") ? src : `${SITE_URL}${src.split("?")[0]}`;
}
